class TabsContent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `<slot></slot>`;
  }

  connectedCallback() {
    requestAnimationFrame(() => this.initializeTabs());
  }

  initializeTabs() {
    // Select from light DOM (slotted content)
    this.tabsButtons = this.querySelectorAll('.tab__button');
    this.tabPanels = this.querySelectorAll('.tab__panel');

    if (!this.tabsButtons.length || !this.tabPanels.length) return;

    // Add event listeners
    this.initTabs();

    // If only one tab, activate it
    if (this.tabsButtons.length === 1) {
      this.activateTab(this.tabsButtons[0]);
      this.tabsButtons[0].classList.add('full-width');
    } else {
      // Optionally activate the first tab by default
      this.activateTab(this.tabsButtons[0]);
    }
  }

  initTabs() {
    this.tabsButtons.forEach((button) => {
      button.addEventListener('click', () => this.activateTab(button));
    });
  }

  activateTab(button) {
    const tabId = button.getAttribute('data-tab');
    if (!tabId) return;

    // Activate panel with matching id
    this.tabPanels.forEach((panel) => {
      panel.classList.toggle('active', panel.id === tabId);
    });

    // Set active state on buttons
    this.tabsButtons.forEach((btn) => {
      btn.classList.toggle('active', btn === button);
    });
  }
}

customElements.define('tabs-content', TabsContent);
